import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";
import { refreshAiAccess } from '@/services/aiAccess';
import Login from "@/views/Login/index.vue";
import Register from "@/views/Register/index.vue";
import Terms from "@/views/Terms.vue";

import Welcome from "@/views/Welcome/index.vue";
import Landing from "@/views/Landing/index.vue";
import AgentsLanding from "@/views/AgentsLanding/index.vue";

import Root from "@/views/Root.vue";

import Dashboard from "@/views/Operations/Dashboard.vue";
import Invoices from "@/views/Operations/Invoices.vue";
import InvoicesReceivable from "@/views/Operations/InvoicesReceivable.vue";
import Invoice from "@/views/Operations/Invoice.vue";
import InvoiceMX from "@/views/Operations/InvoiceMX.vue";
import Forwards from "@/views/Operations/Forwards.vue";
import ForwardsMX from "@/views/Operations/ForwardsMX.vue";
import ActiveForward from "@/views/Operations/ActiveForward.vue";
import Balance from "@/views/Operations/Conversions.vue";
import ConversionDetail from "@/views/Operations/Conversion.vue";
import Calendars from "@/views/Operations/Calendars.vue";
import Compliance from "@/views/Compliance/Documents.vue";

import Conversions from "@/views/History/Conversions.vue";
import Conversion from "@/views/History/Conversion.vue";
import Payments from "@/views/History/Payments.vue";
import Payment from "@/views/History/Payment.vue";
import PaymentsIn from "@/views/History/PaymentsIn.vue";
import PaymentIn from "@/views/History/PaymentIn.vue";
import BeneficiaryDetail from "@/views/History/BeneficiaryDetail.vue";

import Statement from "@/views/Wallets/AccountStatement.vue";
import Suppliers from "@/views/Wallets/Suppliers.vue";
import Clients from "@/views/Wallets/Clients.vue";
import Security from "@/views/Settings/Security.vue";
import Incomes from "@/views/History/Incomes.vue";
import Products from "@/views/Products.vue";
import Agents from "@/views/Subscriptions/Home.vue";
import CollectionAgent from "@/views/Subscriptions/CollectionsAgent.vue";
import LeadsAgent from "@/views/Subscriptions/LeadsAgent.vue";
import creditLine from "@/views/Financing/creditLine/CreditLine.vue";
import revolvingCredit from "@/views/Financing/revolvingCredit/RevolvingCredit.vue";
import fresherCargo from "@/views/Financing/fresherCargo/FresherCargo.vue";
import Bills from "@/views/Subscriptions/Bills.vue";
import Credits from "@/views/Subscriptions/Credits.vue";
import DashboardAI from "@/views/Subscriptions/Dashboard.vue";
import PriceIntelligence from "@/views/Subscriptions/PriceIntelligence.vue";
import DueDiligence from "@/views/Subscriptions/DueDiligence.vue";
import DueDiligenceNew from "@/views/Subscriptions/DueDiligenceNew.vue";
import DueDiligenceReport from "@/views/Subscriptions/DueDiligenceReport.vue";
import Requirements from "@/views/Requirements.vue";
import Forms from "@/views/Forms.vue";
import SecurityAgent from "@/views/SecurityAgent.vue";
import PersonForm from "@/views/PersonForm.vue";
import EnterpriseForm from "@/views/EnterpriseForm.vue";
import Report from "@/views/Report.vue";
import ReportPerson from "@/views/ReportPerson.vue";
import Reports from "@/views/Consultas.vue";
import ProplatCalculator from "@/views/ProplatCalculator/index.vue";
import PayFlex from "@/views/Payflex/Payflex.vue";


// Deudor
import clientesFinancieroDeudor from "@/views/Financing/Traditional/Debtor/Clients.vue";
import financeInvoices from "@/views/Financing/Traditional/Debtor/DeudorDetalle.vue";
import financeDetailInvoice from "@/views/Financing/Traditional/Debtor/FacturaDeudorDetalle.vue";
import calendar from "@/views/Financing/Traditional/Debtor/Calendario.vue";
import financePayment from "@/views/Financing/Traditional/Debtor/PaymentHistory.vue";

// Cedente
import collectionHistory from "@/views/Financing/Traditional/Assignor/CollectionHistory.vue";
import clienteFinanciero from "@/views/Financing/Traditional/Assignor/PaymentHistory.vue";
import financeInvoicesAssignor from "@/views/Financing/Traditional/Assignor/FacturaList.vue";
import financeDetailInvoiceAssignor from "@/views/Financing/Traditional/Assignor/FacturaDetalle.vue";
import calendarAssignor from "@/views/Financing/Traditional/Assignor/Calendario.vue";

// import clienteFlete from "@/views/Financing/Freights/Debtor/Fletes.vue";
// import clienteDeuda from "@/views/Financing/Freights/Debtor/Deudas.vue";
// import clienteFleteDetalle from "@/views/Financing/Freights/Debtor/DetalleFlete.vue";
// import clienteFletePagos from "@/views/Financing/Freights/Debtor/PagoFletes.vue";
// import calendarioClienteFlete from "@/views/Financing/Freights/Debtor/Calendario.vue";

// import fletero from "@/views/Financing/Freights/Freights/Freights.vue";
// import fleteroDetalle from "@/views/Financing/Freights/Freights/FreightsDetail.vue";
// import fleteroPagos from "@/views/Financing/Freights/Freights/PagoFletes.vue";
// import calendarioFletero from "@/views/Financing/Freights/Freights/Calendario.vue";

Vue.use(VueRouter);

const embedAllowedPaths = [
  "/dashboard",
  "/requirements",
  "/invoices",
  "/invoicesReceivable",
  "/forwards",
  "/forwardsMX",
  "/balance",
  "/calendars",
  "/incomes",
  "/conversions",
  "/conversionsMX",
  "/payments",
  "/paymentsMX",
  "/beneficiary",
  "/statement",
  "/suppliers",
  "/clients",
];

const isEmbedAllowedPath = path =>
  embedAllowedPaths.some(
    allowedPath => path === allowedPath || path.startsWith(`${allowedPath}/`)
  );

const routes = [
  {
    path: "/embed/:slug/login",
    name: "EmbedLogin",
    component: Login,
    meta: { embedGuest: true },
  },
  {
    path: "/embed/:slug",
    component: Root,
    meta: { requiresEmbedAuth: true },
    children: [
      {
        path: "dashboard",
        name: "EmbedDashboard",
        component: Dashboard,
        meta: {
          requiresEmbedAuth: true,
          id: "b4f3e431-6e6f-4375-a49f-d2349ef2db1a",
        },
      },
    ],
  },
  {
    path: "*",
    component: () => import("@/views/Login/index.vue"),
  },
  { path: "/home", name: "Landing", component: Landing },
  { path: "/agents", name: "AgentsLanding", component: AgentsLanding },
  { path: "/login", name: "Login", component: Login },
  { path: "/register", name: "Register", component: Register },
  { path: "/terms", name: "Terms", component: Terms },
  { path: "/", name: "Root", component: Root, redirect: { name: "Landing"}, meta: { requiresAuth: true },
    children: [
      { path: "/dashboard", name: "Dashboard", component: Dashboard, meta: { requiresAuth: true, id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a'} },
      { path: "/products", name: "Products", component: Products, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/forms", name: "Forms", component: Forms, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/requirements", name: "Requirements", component: Requirements, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/securityAgent", name: "SecurityAgent", component: SecurityAgent, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/ia-agents", name: "Agents", component: Agents, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/bills", name: "Bills", component: Bills, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/credits", name: "Credits", component: Credits, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/dashboardAI", name: "DashboardAI", component: DashboardAI, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/collectionAgent", name: "CollectionAgent", component: CollectionAgent, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/leadsAgent", name: "LeadsAgent", component: LeadsAgent, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/creditLine", name: "CreditLine", component: creditLine, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/revolvingCredit", name: "RevolvingCredit", component: revolvingCredit, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/fresherCargo", name: "FresherCargo", component: fresherCargo, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/priceIntelligence/:tab(import|lists|compare|explore|history)", name: "PriceIntelligenceTab", component: PriceIntelligence, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/priceIntelligence", name: "PriceIntelligence", redirect: { name: "PriceIntelligenceTab", params: { tab: "import" } }, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/dueDiligence", name: "DueDiligence", component: DueDiligence, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/dueDiligence/new", name: "DueDiligenceNew", component: DueDiligenceNew, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/dueDiligence/:idReport", name: "DueDiligenceReport", component: DueDiligenceReport, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/reports", name: "Reports", component: Reports, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/personForm", name: "PersonForm", component: PersonForm, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/enterpriseForm", name: "EnterpriseForm", component: EnterpriseForm, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/reportEnterprise/:idReport", name: "ReportEnterprise", component: Report, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/reportPerson/:idReport", name: "ReportPerson", component: ReportPerson, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/invoices", name: "Invoices", component: Invoices, meta: { requiresAuth: true, id: '93a6a75e-19cc-4274-9c67-87913ef9e7f7'} },
      { path: "/invoicesReceivable", name: "InvoicesReceivable", component: InvoicesReceivable, meta: { requiresAuth: true, id: '7fecb47b-25fd-4c10-8523-93b62ef4cbe4'}},
      { path: "/invoices/:idInvoice", name: "Invoice", component: Invoice, meta: { requiresAuth: true, id: '93a6a75e-19cc-4274-9c67-87913ef9e7f7'}},
      { path: "/invoicesMX/:idInvoice", name: "InvoiceMX", component: InvoiceMX, meta: { requiresAuth: true, id: '7fecb47b-25fd-4c10-8523-93b62ef4cbe4'}},
      { path: "/forwards", name: "Forwards", component: Forwards, meta: { requiresAuth: true, id: '00e2b5da-6e63-4984-ab1d-b16de53f6324'}, },
      { path: "/forwards/:idActiveForward", name: "ActiveForward", component: ActiveForward, meta: { requiresAuth: true, id: '00e2b5da-6e63-4984-ab1d-b16de53f6324'} },
      { path: "/forwardsMX",name: "ForwardsMX", component: ForwardsMX, meta: { requiresAuth: true, id: '54a68c7a-402b-444b-8236-2b90105fd480'}},
      { path: "/balance", name: "Balance", component: Balance, meta: { requiresAuth: true, id: '785e4626-c4a9-4026-a2ba-fa5313f895c9'},},
      { path: "/calendars", name: "Calendar", component: Calendars, meta: { requiresAuth: true, id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a'} },
      { path: "/balance/:idConversion", name: "Conversion", component: ConversionDetail, meta: { requiresAuth: true, id: '785e4626-c4a9-4026-a2ba-fa5313f895c9'} },
      { path: "/incomes", name: "Incomes", component: Incomes, meta: { requiresAuth: true, id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a'} },
      { path: "/conversions", name: "Conversions", component: Conversions, meta: { requiresAuth: true, id: 'a29b2ef5-0b57-40f2-9782-455f323201f3'} },
      { path: "/conversions/:idConversion", name: "Conversion", component: Conversion, meta: { requiresAuth: true, id: 'a29b2ef5-0b57-40f2-9782-455f323201f3'} },
      { path: "/conversionsMX", redirect: "/conversions" },
      { path: "/payflex", name: "PayFlex", component: PayFlex, meta: { requiresAuth: true, id: 'a29b2ef5-0b57-40f2-9782-455f323201f3'} },
      { path: "/payments", name: "Payments", component: Payments, meta: { requiresAuth: true, id: 'e4bc1bf5-f6ea-42be-9309-19a9c6bc6aba'} },
      { path: "/payments/:idPayment", name: "Payment", component: Payment, meta: { requiresAuth: true, id: 'e4bc1bf5-f6ea-42be-9309-19a9c6bc6aba'} },
      { path: "/paymentsMX", redirect: "/payments" },
      { path: "/paymentsMX/:idPayment", redirect: to => `/payments/${to.params.idPayment}` },
      { path: "/beneficiary/:sPaymentRecipientId", name: "BeneficiaryDetail", component: BeneficiaryDetail, meta: { requiresAuth: true, id: 'e4bc1bf5-f6ea-42be-9309-19a9c6bc6aba'} },
      { path: "/compliance", name: "Compliance", component: Compliance, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/statement", name: "Statement", component: Statement, meta: { requiresAuth: true, id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a'} },
      { path: "/suppliers", name: "Suppliers", component: Suppliers, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      { path: "/clients", name: "Clients", component: Clients, meta: { requiresAuth: true, id: '72318c2b-dad2-440c-8238-26f953a3e289'} },
      { path: "/security", name: "Security", component: Security, meta: { requiresAuth: true, id: '182f53b8-0056-47aa-9638-a52f1f13cf78'} },
      { path: "/calculator", name: "ProplatCalculator", component: ProplatCalculator, meta: { requiresAuth: true, id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a'} },

      // Cliente que debe
      { path: "/clientesFinancieroDeudor", name: "financeInvoices", component: clientesFinancieroDeudor, meta: { requiresAuth: true, id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d'} },
      { path: "/financingInvoices", name: "financeInvoices", component: financeInvoices, meta: { requiresAuth: true, id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d'} },
      { path: "/financingDetailInvoice/:invoiceId", name: "financeDetailInvoice", component: financeDetailInvoice, meta: { requiresAuth: true, id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d'} },
      { path: "/financePayment", name: "financePayment", component: financePayment, meta: { requiresAuth: true, id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d'} },
      { path: "/calendar", name: "calendarTraditional", component: calendar, meta: { requiresAuth: true, id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d'} },

      // Cliente que cede
      { path: "/clientesFinanciero", name: "financeInvoices", component: clienteFinanciero, meta: { requiresAuth: true, id: 'b5c838b1-4797-4296-903d-e08d6e9c4389'} },
      { path: "/financingInvoicesAssignor", name: "financeInvoices", component: financeInvoicesAssignor, meta: { requiresAuth: true, id: 'b5c838b1-4797-4296-903d-e08d6e9c4389'} },
      { path: "/financingDetailInvoiceAssignor", name: "FacturaDeudorDetalle", component: financeDetailInvoiceAssignor, meta: { requiresAuth: true, id: 'b5c838b1-4797-4296-903d-e08d6e9c4389'} },
      { path: "/collectionHistory", name: "financeInvoices", component: collectionHistory, meta: { requiresAuth: true, id: 'b5c838b1-4797-4296-903d-e08d6e9c4389'} },
      { path: "/calendarAssignor", name: "calendarTraditional", component: calendarAssignor, meta: { requiresAuth: true, id: 'b5c838b1-4797-4296-903d-e08d6e9c4389'} },


      // // Cliente Flete
      // { path: "/clienteFlete", name: "clienteFlete", component: clienteFlete, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/clienteDeuda", name: "clienteDeuda", component: clienteDeuda, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/clienteFleteDetalle", name: "clienteFleteDetalle", component: clienteFleteDetalle, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/clienteFletePagos", name: "clienteFletePagos", component: clienteFletePagos, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/calendarioClienteFlete", name: "calendarioClienteFlete", component: calendarioClienteFlete, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },

      // // Fletero
      // { path: "/fletero", name: "fletero", component: fletero, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/fleteroDetalle", name: "fleteroDetalle", component: fleteroDetalle, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/fleteroPagos", name: "fleteroPagos", component: fleteroPagos, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
      // { path: "/calendarioFletero", name: "calendarioFletero", component: calendarioFletero, meta: { requiresAuth: true, id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff'} },
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  // When opening a new route send the user to the default location (top left)
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!Store.state.sToken;
  const isEmbedSession = Store.state.bEmbedSession;
  const userModules = Store.state.sModules.map(mod => mod.sModuleId) || [];

  if (to.matched.some(record => record.meta.requiresEmbedAuth)) {
    if (!isAuthenticated || !isEmbedSession) {
      return next({
        name: "EmbedLogin",
        params: { slug: to.params.slug },
      });
    }

    if (to.meta.id) {
      const hasAccess = userModules.includes(to.meta.id);

      if (!hasAccess) {
        return next({
          name: "EmbedLogin",
          params: { slug: to.params.slug },
        });
      }
    }

    return next();
  }

  if (to.meta.embedGuest && isAuthenticated && isEmbedSession) {
    return next({
      name: "EmbedDashboard",
      params: { slug: to.params.slug },
    });
  }

  if (
    isEmbedSession &&
    to.matched.some(record => record.meta.requiresAuth) &&
    !isEmbedAllowedPath(to.path)
  ) {
    return next({
      name: "EmbedDashboard",
      params: {
        slug: Store.state.embedIntegrationSlug || "default",
      },
    });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      return next("/login");
    }

    if (to.name === "Login") {
      return next({ name: "Root" });
    }

    const aiRoutes = ['Agents', 'DashboardAI', 'Bills', 'Credits', 'DueDiligence', 'DueDiligenceNew', 'DueDiligenceReport', 'CollectionAgent', 'LeadsAgent', 'PriceIntelligence'];
    if (aiRoutes.includes(to.name)) {
      // Stripe returns to the existing billing callback; reconcile on Start
      // before deciding access, including when webhooks have not arrived yet.
      if (to.name === 'Bills' && ['success', 'cancel'].includes(to.query.checkout)) {
        return next({ name: 'Agents', query: to.query, replace: true });
      }
      const allowed = await refreshAiAccess();
      const comingSoon = ['CollectionAgent', 'LeadsAgent', 'PriceIntelligence'].includes(to.name);
      if (comingSoon) return next({ name: allowed ? 'DashboardAI' : 'Agents', replace: true });
      if (to.name === 'Agents' && allowed && !to.query.checkout) return next({ name: 'DashboardAI', replace: true });
      if (to.name !== 'Agents' && !allowed) return next({ name: 'Agents', replace: true });
    }

    if (to.meta.id) {
      const hasAccess = userModules.includes(to.meta.id);
      if (!hasAccess) {
        return next("/home");
      }
    }

    return next();
  }

  if (isAuthenticated && to.name === "Login") {
    return next({ name: "Root" });
  }

  return next();
});

export default router;
